import React from 'react';
import { IMaskInput } from 'react-imask';

interface Props extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  value: string;
}

const PhoneMask = React.forwardRef<HTMLInputElement, Props>(
  function PhoneMask(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask={['(00) 0000-0000', '(00) 00000-0000']}
        inputRef={ref}
        onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
        overwrite
      />
    );
  }
);

export default PhoneMask;
